var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyC1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_1031_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.202,
    height: 174.202,
    viewBox: "0 0 174.202 174.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_971_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_977_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1030_",
    d: "M155.615,33.322H161a3.4,3.4,0,1,0,0-6.8H148.077a3.4,3.4,0,0,0-3.4,3.4V42.842a3.4,3.4,0,1,0,6.8,0V39.1A80.3,80.3,0,1,1,87.1,6.8a81.511,81.511,0,0,1,9.8.591A3.4,3.4,0,0,0,97.718.641,88.338,88.338,0,0,0,87.1,0a87.1,87.1,0,0,0-61.59,148.691,87.1,87.1,0,0,0,130.1-115.369Z",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1029_",
    d: "M79.9,94.364a3.4,3.4,0,0,0-4.692,1.054A64.925,64.925,0,1,0,95.529,75.138a3.4,3.4,0,0,0,3.626,5.753,58.149,58.149,0,1,1-10.15,90.341,58.517,58.517,0,0,1-8.052-72.175A3.4,3.4,0,0,0,79.9,94.364Z",
    transform: "translate(-43.017 -43.018)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1028_",
    d: "M379.569,253.13h4.193a3.4,3.4,0,0,0,0-6.8h-4.193a3.4,3.4,0,0,0,0,6.8Z",
    transform: "translate(-248.266 -162.574)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1004_",
    d: "M103.835,249.406a3.4,3.4,0,0,0,3.4,3.4h4.193a3.4,3.4,0,1,0,0-6.8h-4.193A3.4,3.4,0,0,0,103.835,249.406Z",
    transform: "translate(-68.529 -162.36)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1001_",
    d: "M253.13,111.428v-4.193a3.4,3.4,0,1,0-6.8,0v4.193a3.4,3.4,0,1,0,6.8,0Z",
    transform: "translate(-162.574 -68.529)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1415_",
    d: "M246.006,379.569v4.193a3.4,3.4,0,1,0,6.8,0v-4.193a3.4,3.4,0,1,0-6.8,0Z",
    transform: "translate(-162.36 -248.266)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_996_",
    d: "M194.777,167.2a3.4,3.4,0,0,0-4.809,4.809l11.523,11.523a11.714,11.714,0,1,0,20.657,0L245.4,160.285a3.4,3.4,0,0,0-4.809-4.809l-23.251,23.251a11.689,11.689,0,0,0-11.039,0Zm21.956,21.852a4.913,4.913,0,1,1-4.913-4.913A4.919,4.919,0,0,1,216.733,189.056Z",
    transform: "translate(-124.719 -101.955)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_980_",
    d: "M123.982,123.982a3.4,3.4,0,1,0-2.4,1A3.414,3.414,0,0,0,123.982,123.982Z",
    transform: "translate(-77.996 -77.996)",
    fill: "#170d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_979_",
    d: "M318.838,16.678a3.4,3.4,0,1,0-2.4-1A3.414,3.414,0,0,0,318.838,16.678Z",
    transform: "translate(-208.184 -6.519)",
    fill: "#170d65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyC1);
export default __webpack_public_path__ + "static/media/whyC1.73aa86dc30f3f921d89a22523faa7a2a.svg";
export { ForwardRef as ReactComponent };